import { Box, ThemeProvider } from "@mui/material";
// import { Container } from "@mui/system";
import { useEffect } from "react";

import Appbar from "./components/appbar";

import theme from "./styles/theme";

import { BrowserRouter as Router, Route, Routes, } from "react-router-dom";

import About from './pages/about'
import Work from './pages/work'
import Home from './pages/home'
import Footprint from './pages/footprint'
import Photo from './pages/photo'
import Musing from './pages/musing'
import Thought from './pages/thought'
import Gallery from './pages/gallery'
import { Footer } from "./components/footer";




function App() {
  useEffect(()=>{
    document.title = "Paul Adeleke - Portfolio"
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <>
        {/* <UIProvider> </UIProvider> */}
      <Router>
      
    
      <Appbar/> 
     
     <Box
   style={{ 
    margin: -9,
    padding: 0,
  }}>
    
  
  </Box>

  {/* <AppBar/>  */}

        <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/about" element={<About/>}/>
        
        <Route path="/work" element={<Work/>}/>
        <Route path="/thought" element={<Thought/>}/>
        <Route path="/footprint" element={<Footprint/>}/>
        <Route path="/photo" element={<Photo/>}/>
        <Route path="/musing" element={<Musing/>}/>
        <Route path="/gal" element={<Gallery/>}/>
        </Routes>
      </Router>
     

   
     

      <Footer/>
     
      </>
      </ThemeProvider>


   
    
  //   <ThemeProvider theme={theme}>
  //   {/* <Container
  //   maxWidth="xl"
  //   sx={{
  //     backgroundColor:"#fff",
  //   }} > */}


  //   <Box
  //  style={{ 
  //   margin: -9,
  //   padding: 0,
  // }}>
    
  // <Appbar/>   
  // </Box>
  // {/* </Container> */}
  //   </ThemeProvider>
    //
     );
}

export default App;
